module.exports = __webpack_public_path__ + "img/kj-min.1b0a77ee.webp";